var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.query.framed)?_c('div',[_c('FullPage')],1):_c('div',[_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }